__turbopack_context__.v({
  "divider": "_9XaaEG_divider",
  "root": "_9XaaEG_root",
  "sticky": "_9XaaEG_sticky",
  "totalFoundLabel": "_9XaaEG_totalFoundLabel",
});
